var utils = require('./PerformanceTimingUtil');
import IndexedDBUtil from './IndexedDBUtil';
var formatMs = utils.formatMs;
var isObject = utils.isObject;
var checkResourceType = utils.checkResourceType;
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';

function Performance() {};

Performance.prototype = {
  // 获取数据信息
  getPerformanceTiming(e){
    // 初始化数据
    this.init();
    this.formLabel = e.formLabel;
    if (!isObject(this.timing)) {
      console.log('值需要是一个对象类型');
      return;
    }
    // 过早获取 loadEventEnd值会是0
    var  loadTime = this.timing.loadEventEnd - this.timing.navigationStart;
    if (loadTime < 0) {
      setTimeout(() => {
        this.getPerformanceTiming(e);
      }, 200);
      return;
    }
    // 获取解析后的数据
    this.afterDatas.enteriesResouceDataFormat = this._setEnteries();
    this.afterDatas.timingFormat = this._setTiming(loadTime);
    this.afterDatas.memory = this._setMemory();
    this.afterDatas.timingFormatJson=this._setTimingJson(loadTime);

    this._showTiming();
    var data = {"timing":this.afterDatas.timingFormat,"memory":this.afterDatas.memory};
    return data;
  },
  init: function() {
    this.timing = window.performance.timing;
    this.memory = window.performance.memory;
    // 获取资源类型为 resource的所有数据
    this.enteriesResouceData = window.performance.getEntriesByType('resource');
  },
  // 保存原始数据
  timing: {},
  formLabel:'',
  // 原始enteries数据
  enteriesResouceData: [],
  // 保存解析后的数据
  afterDatas: {
    memory:{},
    timingFormat: {},
    timingFormatJson: {},
    enteriesResouceDataFormat: {},
    enteriesResouceDataTiming: {
      "js": 0,
      "css": 0,
      "image": 0,
      "video": 0,
      "others": 0
    },
    timingMax:{},
    memoryMax:{},
    requestMax:{}
  },
  _setTiming: function(loadTime) {
    var timing = this.timing;
    // 对数据进行计算
    let otherdata = [];
    for( var key in this.afterDatas.enteriesResouceDataFormat ){
      let b = {};
      b[key + "--- 共加载时间" + formatMs(this.afterDatas.enteriesResouceDataTiming[key])] = this.afterDatas.enteriesResouceDataFormat[key];
      otherdata.push(b);
    }
    var data = {
      "formId":window.formId,
      "formLable":this.formLabel,
      "startDateTime":this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
      "clientSessionId": window.parent.userInfos.userSessionId,
      "userId": window.parent.userInfos.userId,
      "connectStart": timing.connectStart+"",
      "connectEnd": timing.connectEnd+"",
      "domComplete": timing.domComplete+"",
      "domInteractive": timing.domInteractive+"",
      "domContentLoadedEventEnd": timing.domContentLoadedEventEnd+"",
      "domContentLoadedEventStart": timing.domContentLoadedEventStart+"",
      "domainLookupEnd": timing.domainLookupEnd+"",
      "domainLookupStart": timing.domainLookupStart+"",
      "navigationStart":timing.navigationStart+"",
      "requestStart": timing.requestStart+"",
      "responseEnd": timing.responseEnd+"",
      "responseStart": timing.responseStart+"",
      "secureConnectionStart": timing.secureConnectionStart+"",
      "staticResources": otherdata+"",
    };
    return data;
  },
  _setTimingJson: function(loadTime) {
    var timing = this.timing;
    // 对数据进行计算
    let otherdata = [];
    for( var key in this.afterDatas.enteriesResouceDataFormat ){
      let b = {};
      b[key + "--- 共加载时间" + formatMs(this.afterDatas.enteriesResouceDataTiming[key])] = this.afterDatas.enteriesResouceDataFormat[key];
      otherdata.push(b);
    }
    var data = {
      "formId":window.formId,
      "formLable":this.formLabel,
      "startDateTime":this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
      "clientSessionId": window.parent.userInfos.userSessionId,
      "userId": window.parent.userInfos.userId,
      "connectStart": timing.connectStart+"",
      "connectEnd": timing.connectEnd+"",
      "domComplete": timing.domComplete+"",
      "domInteractive": timing.domInteractive+"",
      "domContentLoadedEventEnd": timing.domContentLoadedEventEnd+"",
      "domContentLoadedEventStart": timing.domContentLoadedEventStart+"",
      "domainLookupEnd": timing.domainLookupEnd+"",
      "domainLookupStart": timing.domainLookupStart+"",
      "navigationStart":timing.navigationStart+"",
      "requestStart": timing.requestStart+"",
      "responseEnd": timing.responseEnd+"",
      "responseStart": timing.responseStart+"",
      "secureConnectionStart": timing.secureConnectionStart+"",
      "staticResources": otherdata,
    };
    var timingMax = {
      "画面ID":window.formId,
      "画面名称":this.formLabel,
      "触发时间":this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
      "SessionID": window.parent.userInfos.userSessionId,
      "用户ID": window.parent.userInfos.userId,
      "重定向耗时": formatMs(timing.redirectEnd - timing.redirectStart),
      "Appcache耗时": formatMs(timing.domainLookupStart - timing.fetchStart),
      "DNS查询耗时": formatMs(timing.domainLookupEnd - timing.domainLookupStart),
      "TCP链接耗时": formatMs(timing.connectEnd - timing.connectStart),
      "HTTP请求耗时": formatMs(timing.responseEnd - timing.responseStart),
      "请求完毕到DOM加载耗时": formatMs(timing.domInteractive - timing.responseEnd),
      "解析DOM树耗时": formatMs(timing.domComplete - timing.domInteractive),
      "白屏时间耗时": formatMs(timing.responseStart - timing.navigationStart),
      "load事件耗时": formatMs(timing.loadEventEnd - timing.loadEventStart),
      "页面加载完成的时间": formatMs(loadTime),
      "静态资源加载":otherdata
    };
    this.afterDatas.timingMax = timingMax;
    return data;
  },
  _setMemory: function(){
    var memory = this.memory;
    // 对数据进行计算
    let otherdata = [];
    for( var key in this.afterDatas.enteriesResouceDataFormat ){
      let b = {};
      b[key + "--- 共加载时间" + formatMs(this.afterDatas.enteriesResouceDataTiming[key])] = this.afterDatas.enteriesResouceDataFormat[key];
      otherdata.push(b);
    }
    var data = {
      "formId":window.formId,
      "formLable":this.formLabel,
      "startDateTime":this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
      "clientSessionId": window.parent.userInfos.userSessionId,
      "userId": window.parent.userInfos.userId,
      "jsHeapSizeLimit": memory.jsHeapSizeLimit+"",
      "totalJSHeapSize": memory.totalJSHeapSize+"",
      "usedJSHeapSize": memory.usedJSHeapSize+""
    };
    this.afterDatas.memoryMax={
      "画面ID":window.formId,
      "画面名称":this.formLabel,
      "触发时间":this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
      "SessionID": window.parent.userInfos.userSessionId,
      "用户ID": window.parent.userInfos.userId,
      "内存大小限制": memory.jsHeapSizeLimit+"",
      "总内存": memory.totalJSHeapSize+"",
      "已使用的内存": memory.usedJSHeapSize+""
    };
    return data;
  },
  _setEnteries: function() {
    var enteriesResouceData = this.enteriesResouceData;
    var imageArrs = [],
      jsArrs = [],
      cssArrs = [],
      videoArrs = [],
      otherArrs = [];
    enteriesResouceData.map(item => {
      var d = {
        '资源名称': item.name,
        'HTTP协议类型' : item.nextHopProtocol,
        "TCP链接耗时" : formatMs(item.connectEnd - item.connectStart),
        "加载时间" : formatMs(item.duration)
      };
      switch(checkResourceType(item.name)) {
        case 'image':
          this.afterDatas.enteriesResouceDataTiming.image += item.duration;
          imageArrs.push(d);
          break;
        case 'javascript':
          this.afterDatas.enteriesResouceDataTiming.js += item.duration;
          jsArrs.push(d);
          break;
        case 'css':
          this.afterDatas.enteriesResouceDataTiming.css += item.duration;
          cssArrs.push(d);
          break;
        case 'video':
          this.afterDatas.enteriesResouceDataTiming.video += item.duration;
          videoArrs.push(d);
          break;
        case 'others':
          this.afterDatas.enteriesResouceDataTiming.others += item.duration;
          otherArrs.push(d);
          break;
      }
    });
    return {
      'js': jsArrs,
      'css': cssArrs,
      'image': imageArrs,
      'video': videoArrs,
      'others': otherArrs
    }
  },
  _showTiming: function() {
      let allData = {};
      allData['id'] = new Date().getTime();
      allData['data'] = this.afterDatas.memoryMax;
      IndexedDBUtil.openDB(window.parent.userInfos.subSysId,null);
      setTimeout(function () {
        IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name7,allData);
    }, 2000);

      let allData2 = {};
      allData2['id'] = new Date().getTime();
      allData2['data'] = this.afterDatas.timingMax;
      IndexedDBUtil.openDB(window.parent.userInfos.subSysId,null);
      setTimeout(function () {
        IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name5,allData2);
    }, 2000);
  
  },
  gerPerformanceResource(formReq){
    var arr =window.performance.getEntriesByType('resource');
    var arrData = [];
    if(formReq.length==0){
      formReq = arr;
      for(let j=0;j<arr.length;j++){
        let allData = {
          "formId":window.formId,
          "startDateTime": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
          "clientSessionId": window.parent.userInfos.userSessionId,
          "userId": window.parent.userInfos.userId,
          "connectEnd": arr[j].connectEnd+"",
          "connectStart": arr[j].connectStart+"",
          "domainLookupEnd": arr[j].domainLookupEnd+"",
          "domainLookupStart": arr[j].domainLookupStart+"",
          "requestStart": arr[j].requestStart+"",
          "responseEnd": arr[j].responseEnd+"",
          "responseStart": arr[j].responseStart+"",
          "decodedBodySize": arr[j].decodedBodySize+"",
          "secureConnectionStart": arr[j].secureConnectionStart+"",
          "url":arr[j].name,
          "requestName":"",
          "duration":arr[j].duration,
          "initiatorType":arr[j].initiatorType
        };
        let allDataJs = {
          "画面ID":window.formId,
          "触发时间": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
          "SessionId": window.parent.userInfos.userSessionId,
          "用户ID": window.parent.userInfos.userId,
          "连接类型":arr[j].initiatorType,
          "connectTime": formatMs(arr[j].connectEnd-arr[j].connectStart),
          "stalled":formatMs(arr[j].requestStart-arr[j].connectEnd),
          "DNS连接时间": formatMs(arr[j].domainLookupEnd-arr[j].domainLookupStart),
          "TTFB":formatMs(arr[j].responseStart-arr[j].requestStart),
          "响应时间": formatMs(arr[j].responseEnd-arr[j].responseStart),
          "url路径":arr[j].name,
          "请求名称":"",
          "加载总时耗":arr[j].duration
        };
        if(arr[j].responseStart ===0){
          allDataJs['响应时间'] = '0ms';
        }
        let indexDBData = {};
        //id 光时间搓 可能存在重复 所以id 后三位为序列号
        indexDBData['id'] = new Date().getTime()+this.coder(j+"",3);
        indexDBData['data']=allDataJs;
        IndexedDBUtil.openDB(window.parent.userInfos.subSysId,null);
        IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name6,indexDBData);

        arrData.push(allData);
      }
    }else{
      let newarr = arr.filter(v => !formReq.includes(v));
      for(let g=0;g<newarr.length;g++){
        let allData = {
          "formId":window.formId,
          "startDateTime":this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
          "clientSessionId": window.parent.userInfos.userSessionId,
          "userId": window.parent.userInfos.userId,
          "connectEnd": newarr[g].connectEnd+"",
          "connectStart": newarr[g].connectStart+"",
          "domainLookupEnd": newarr[g].domainLookupEnd+"",
          "domainLookupStart": newarr[g].domainLookupStart+"",
          "requestStart": newarr[g].requestStart+"",
          "responseEnd": newarr[g].responseEnd+"",
          "responseStart": newarr[g].responseStart+"",
          "decodedBodySize": newarr[g].decodedBodySize+"",
          "secureConnectionStart": newarr[g].secureConnectionStart+"",
          "url":newarr[g].name,
          "requestName":"",
          "duration":newarr[g].duration,
          "initiatorType":newarr[g].initiatorType
        };
        let allDataJs = {
          "画面ID":window.formId,
          "触发时间": this.getCurrentData("yyyy-MM-dd hh:mm:ss"),
          "SessionId": window.parent.userInfos.userSessionId,
          "用户ID": window.parent.userInfos.userId,
          "连接类型":newarr[g].initiatorType,
          "connectTime": formatMs(newarr[g].connectEnd-newarr[g].connectStart),
          "stalled":formatMs(newarr[g].requestStart-newarr[g].connectEnd),
          "DNS连接时间": formatMs(newarr[g].domainLookupEnd-newarr[g].domainLookupStart),
          "TTFB":formatMs(newarr[g].responseStart-newarr[g].requestStart),
          "响应时间": formatMs(newarr[g].responseEnd-newarr[g].responseStart),
          "url路径":newarr[g].name,
          "请求名称":"",
          "加载总时耗":newarr[g].duration
        };
        if(newarr[g].responseStart ===0){
          allDataJs['响应时间'] = '0ms';
        }
        let indexDBData = {};
        //id 光时间搓 可能存在重复 所以id 后三位为序列号
        indexDBData['id'] = new Date().getTime()+this.coder(g+"",3);
        indexDBData['data']=allDataJs;
        IndexedDBUtil.openDB(window.parent.userInfos.subSysId,null);
        IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name6,indexDBData);
        arrData.push(allData);
      }
      formReq = arr;
    }

    var timingFormat = {remoteClass:"java.util.Map", PerformanceXmlHttpRequest:arrData};
    var command = Command.createService("gongqi.erp.framework.services.ClientLoggingService","saveLog","void");
    command.appendArg(timingFormat ,"Object");
    var remoteArg = {
        command:command,
        resultFunction:this.success,
        faultFunction:this.error,
        autoLock:false,
        autoUnlock:false
    };
    ServiceHelper.addTokenWithCommand(remoteArg);
    return formReq;
  },

  deletePerformeTiming(){
    //IndexedDBUtil.openDB(window.userInfos.subSysId,null);
    setTimeout(function () {
      if(IndexedDBUtil.DB.db){
        var transaction  = IndexedDBUtil.DB.db.transaction(IndexedDBUtil.DB.name5,'readwrite');
        var store = transaction.objectStore(IndexedDBUtil.DB.name5);
        //删除两天前的数据
        let time=(new Date().getTime())-172800000;
        let request = store.openCursor(IDBKeyRange.upperBound(time,true));
        let data = [];
        request.onerror = function () 
        {
            alert("上传网络错误日志时在获取浏览器数据库数据错误");
        };
        request.onsuccess = function (e) 
        {
            let result = e.target.result;
            if (result && result !== null) 
            {
                if(result.value && result.value.id && result.value.data)
                    data.push(result.value.data);
                result.delete();
                result.continue();
            } 
        };
      }
    },1000);
    setTimeout(function () {
      //IndexedDBUtil.openDB(window.userInfos.subSysId,null);
      if(IndexedDBUtil.DB.db){
        var transaction  = IndexedDBUtil.DB.db.transaction(IndexedDBUtil.DB.name7,'readwrite');
        var store = transaction.objectStore(IndexedDBUtil.DB.name7);
        //删除两天前的数据
        let time=(new Date().getTime())-172800000;
        let request = store.openCursor(IDBKeyRange.upperBound(time,true));
        let data = [];
        request.onerror = function () 
        {
            alert("上传网络错误日志时在获取浏览器数据库数据错误");
        };
        request.onsuccess = function (e) 
        {
            let result = e.target.result;
            if (result && result !== null) 
            {
                if(result.value && result.value.id && result.value.data)
                    data.push(result.value.data);
                result.delete();
                result.continue();
            } 
        };
      }
    },1000);
    setTimeout(function () {
      //IndexedDBUtil.openDB(window.userInfos.subSysId,null);
      if(IndexedDBUtil.DB.db){
        var transaction  = IndexedDBUtil.DB.db.transaction(IndexedDBUtil.DB.name6,'readwrite');
        var store = transaction.objectStore(IndexedDBUtil.DB.name6);
        //删除两天前的数据
        let time=(new Date().getTime())-172800000;
        time =  time+"000";
        let request = store.openCursor(IDBKeyRange.upperBound(time,true));
        let data = [];
        request.onerror = function () 
        {
            alert("上传网络错误日志时在获取浏览器数据库数据错误");
        };
        request.onsuccess = function (e) 
        {
            let result = e.target.result;
            if (result && result !== null) 
            {
                if(result.value && result.value.id && result.value.data)
                    data.push(result.value.data);
                result.delete();
                result.continue();
            } 
        };
      }
    },1000);
  },
  getDataAndDelete:function(db,storeName,fag)
  {
      var transaction  = IndexedDBUtil.DB.db.transaction(db,storeName,'readwrite');
      var store = transaction.objectStore(storeName);
      //删除两天前的数据
      let time=(new Date().getTime())-172800000;
      if(fag){
        time =  time+"000";
      }
      let request = store.openCursor(IDBKeyRange.upperBound(time,true));
      let data = [];
      request.onerror = function () 
      {
          alert("上传网络错误日志时在获取浏览器数据库数据错误");
      };
      request.onsuccess = function (e) 
      {
          let result = e.target.result;
          if (result && result !== null) 
          {
              if(result.value && result.value.id && result.value.data)
                  data.push(result.value.data);
              result.delete();
              result.continue();
          } 
      };
  },

  sendTimingAndMemoryToServer(timing,memory){
    if(timing.length>0 || memory.length>0){
      var timingFormat = {remoteClass:"java.util.Map", PerformanceTiming:timing,PerformanceMemory:memory};
      var command = Command.createService("gongqi.erp.framework.services.ClientLoggingService","saveLog","void");
      command.appendArg(timingFormat ,"Object");
      var remoteArg = {
          command:command,
          resultFunction:this.success,
          faultFunction:this.error,
          autoLock:false,
          autoUnlock:false
      };
      ServiceHelper.addTokenWithCommand(remoteArg);
    }
  },






getCurrentData(fmt){
      var date = new Date();
      var o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        "S": date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          return fmt;
    
},
guid2() {
  function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
},
// content: 主题内容 如：'10',digit:数据长度：如:3 返回 '010'
coder(content,digit){
  var result = "";
  for(let i=0;i<digit-content.length;i++){
    result = result+"0";
  }
  return result+content;
},
success(data){
  window.parent.performanceData = {'tim':[],'mem':[]};
},
error(data){
  window.parent.performanceData = {'tim':[],'mem':[]};
}
};

var Per = new Performance();
module.exports = Per;


// WEBPACK FOOTER //
// ./src/utils/PerformancTiming.js